import SeoHead from '../../components/feature/SeoHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Desguace en Vilafranca del Penedès – Compra de Coches',
  description: 'Compramos coches en Vilafranca del Penedès al mejor precio. Siniestrados, averiados, sin ITV. Recogida gratuita y pago inmediato.',
  provider: {
    '@type': 'AutoDealer',
    name: 'Desguace Barcelona',
    telephone: '+34932932913',
    address: { '@type': 'PostalAddress', addressLocality: 'Vilafranca del Penedès', addressRegion: 'Cataluña', addressCountry: 'ES' },
  },
  areaServed: { '@type': 'City', name: 'Vilafranca del Penedès' },
  url: `${siteUrl}/desguace-vilafranca`,
};

export default function DesguaceVilafrancaPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Desguace en Vilafranca del Penedès | Mejor Precio | Recogida Gratis"
        description="Desguace en Vilafranca del Penedès. Compramos coches siniestrados, averiados o sin ITV al mejor precio. Recogida gratuita y pago inmediato."
        keywords="desguace Vilafranca Penedès, vender coche Vilafranca, compra coches Vilafranca del Penedès, desguace Alt Penedès"
        canonical={`${siteUrl}/desguace-vilafranca`}
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1a2332] to-[#2d3e50]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              Desguace en Vilafranca del Penedès
            </h1>
            <p className="text-xl text-white/90 leading-relaxed mb-8">
              Compramos tu coche en Vilafranca al mejor precio. Recogida gratuita y pago inmediato
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20vender%20mi%20coche%20en%20Vilafranca" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-10 py-5 bg-[#25D366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3"></i>
                Vender mi Coche en Vilafranca
              </a>
              <a 
                href="tel:+34932932913" 
                className="inline-flex items-center justify-center px-10 py-5 bg-white text-[#1a2332] rounded-full font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-3"></i>
                932 932 913
              </a>
            </div>
          </div>
        </section>

        {/* Zonas de Vilafranca */}
        <section className="py-16 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-black text-[#1a2332] mb-8 text-center">
              Zonas de Vilafranca Donde Operamos
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {['Centro', 'Sant Julià', 'Masia Bach', 'Barri Nou', 'Sant Pere dels Arquells', 'Zona Industrial', 'Polígono Can Petit', 'Polígono Can Ratés', 'Barri de la Girada', 'Barri de Sant Joan', 'Barri de Sant Miquel', 'Comarca Alt Penedès'].map((zona, index) => (
                <div key={index} className="bg-white p-4 rounded-lg text-center shadow-sm">
                  <i className="ri-map-pin-line text-[#ff6b35] text-xl mr-2"></i>
                  <span className="text-sm font-medium text-[#1a2332]">{zona}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Ventajas */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-black text-[#1a2332] mb-12 text-center">
              ¿Por Qué Elegirnos en Vilafranca?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">Recogida Gratuita</h3>
                <p className="text-gray-600 leading-relaxed">
                  Vamos a buscar tu coche a cualquier zona de Vilafranca sin coste adicional
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-money-euro-circle-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">Mejor Precio</h3>
                <p className="text-gray-600 leading-relaxed">
                  Ofrecemos las mejores tarifas del mercado en Vilafranca y Alt Penedès
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">Pago Inmediato</h3>
                <p className="text-gray-600 leading-relaxed">
                  Recibes el dinero al momento de la recogida, sin esperas
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-[#ff6b35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-3-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#1a2332] mb-3">Gestión Completa</h3>
                <p className="text-gray-600 leading-relaxed">
                  Nos encargamos de todos los trámites y documentación legal
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Tipos de Coches */}
        <section className="py-16 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-black text-[#1a2332] mb-12 text-center">
              Tipos de Coches que Compramos en Vilafranca
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-car-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332]">Coches Siniestrados</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Compramos vehículos declarados siniestro total por aseguradoras
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-tools-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332]">Coches Averiados</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos con averías mecánicas, eléctricas o de motor
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-file-warning-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332]">Coches Sin ITV</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos que no han pasado la ITV o llevan años sin revisión
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-alert-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332]">Coches Accidentados</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos con daños por colisión que prefieres vender
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332]">Coches Antiguos</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Vehículos con muchos años que ya no son rentables de mantener
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-[#ff6b35] rounded-full flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-white text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332]">Coches en Buen Estado</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  También compramos vehículos en perfecto estado si necesitas vender rápido
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-br from-[#1a2332] to-[#2d3e50] rounded-2xl p-12 text-center text-white">
              <h2 className="text-4xl font-black mb-4">
                ¿Tienes un Coche para Vender en Vilafranca?
              </h2>
              <p className="text-xl mb-8 text-white/90">
                Contacta ahora y obtén tu tasación gratuita en menos de 24 horas
              </p>
              <a 
                href="https://wa.me/34932932913?text=Hola%20Desguaces%20Barcelona%2C%20quiero%20vender%20mi%20coche%20en%20Vilafranca" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-10 py-5 bg-[#25D366] text-white rounded-full font-bold text-lg hover:bg-[#1da851] transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-3"></i>
                Contactar por WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
